import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-chair-workouts': {
			// ?safe&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_m_chair_fitness_age~1
			funnel: {
				id: 'ob-male-chair-workouts-fitness-age',
				locale: ['en'],
			},
		},
	},
]

export default config
